import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createBlock as _createBlock } from "vue"
import _imports_0 from '@/assets/img/warning-orange-icon.svg'


const _hoisted_1 = { class: "tw-p-10 modal-offer-access" }
const _hoisted_2 = { class: "tw-flex tw-items-center tw-gap-[15px]" }
const _hoisted_3 = { class: "tw-text-[25px] tw-text-[#211F58] tw-font-[600] tw-leading-none" }
const _hoisted_4 = { class: "dropdown" }
const _hoisted_5 = { class: "dropdown" }
const _hoisted_6 = { class: "tw-flex tw-justify-between" }
const _hoisted_7 = {
  key: 0,
  class: "tw-h-[14px] tw-w-[14px] tw-mr-[10px]",
  src: "/img/lock1_icon.svg",
  alt: "icon"
}
const _hoisted_8 = {
  class: /*#__PURE__*/_normalizeClass('tw-text-[#231F20]')
}
const _hoisted_9 = /*#__PURE__*/_createElementVNode("img", {
  class: "right-arrow",
  src: "/img/blue_right_arrow_icon.svg"
}, null, -1)
const _hoisted_10 = {
  key: 0,
  class: "tw-flex tw-bg-[#FE9A0526] tw-text-[11px] tw-text-[#FE9A05] tw-font-medium tw-mt-[10px] tw-leading-[130%] tw-py-[8px] tw-px-[12px] tw-rounded-md"
}
const _hoisted_11 = /*#__PURE__*/_createElementVNode("div", { class: "tw-flex tw-item-center tw-mr-[10px]" }, [
  /*#__PURE__*/_createElementVNode("img", { src: _imports_0 })
], -1)
const _hoisted_12 = { class: "dropdown" }
const _hoisted_13 = { class: "button-container tw-flex tw-justify-end tw-mt-[40px]" }

import {
  IsEmailValidWhileTyping,
  IsSpecialCharEmailValid,
  getComponentUiText,
} from "@/utils/utilities";
import { onBeforeMount, reactive, ref, watch, Ref, computed } from "vue";

import Modal from "@/components/common/modal.vue";
import ModalHeader from "@/components/common/modalHeader.vue";
import { IDropDownData } from "@/interfaces/common/IDropDown";
import useVuelidate from "@vuelidate/core";
import { email, required, helpers } from "@vuelidate/validators";
import { IOrgAccessOfferRequest } from "@/interfaces/orgInterfaces";
import { postOrgAccessOffer } from "@/services/org";
import BaseInput from "@/components/common/form/baseInput.vue";
import BaseDropDown from "@/components/common/form/baseDropDown.vue";
import store from "@/store";
import EventEmitter, { EmitterEvents } from "@/utils/eventEmitter";
import { IToastMessage, ToastVariant } from "@/interfaces/common/IToastMessage";
import BaseForm from "../common/form/baseForm.vue";
import { showErrorAPI } from "@/services/apiRoutes";
import { Invite } from "@/services/apiRoutes/routes";
import ButtonLoading from "../common/buttonLoading.vue";
const DEFAULT_MAX_WIDTH_MODAL = 65;


export default /*#__PURE__*/_defineComponent({
  __name: 'offerAccessModal',
  props: {
  show: {
    type: Boolean,
    required: false,
  },
},
  emits: ["update:show", "add:organisation"],
  setup(__props, { emit }) {

const props = __props;

const orgRelationshipOptions: Ref<IDropDownData[]> = computed(() => {
  const orgAccessType = store.getters["Org/getOrgAccessType"];
  return orgAccessType.map((relationship) => ({
    name: relationship.name,
    id: relationship.id,
    isLockable: relationship.isLockable,
  }));
});

const lockStatusOptions: IDropDownData[] = [
  {
    id: true,
    value: true,
    name: getComponentUiText(
      "app-settings-organisation-manage-access-create-org-modal-locked-status-1",
    ),
    iconSrc: "/img/lock1_icon.svg",
  },
  {
    id: false,
    value: false,
    name: getComponentUiText(
      "app-settings-organisation-manage-access-create-org-modal-unlocked-status-1",
    ),
  },
];

const roles: Ref<IDropDownData[]> = computed(() => {
  const rolesData = store.getters["Org/getOrgRolesData"];
  return rolesData.map((role) => ({
    name: role.roleName,
    id: role.roleId,
  }));
});

const listNotValidDomain = computed(
  () => store.getters["Org/getOrgDomainsInvalid"],
);

const currentOrg = computed(() => store.state.Org.currentOrg);

const titleHeader = ref("");

const isCallApi = ref(false);



// Custom validation domain.
const validateForDomain = (text: string) => {
  return !listNotValidDomain.value.some((domain) => text.includes(domain));
};
// Form modal and validation.

const initialForm: IOrgAccessOfferRequest = {
  email: "",
  orgToOrgTypeId: null,
  isLocked: true,
  roleId: "",
};
const formModel = reactive({ ...initialForm });
const getDomainMessage = computed(() => {
  const email = formModel.email;
  return getComponentUiText(
    "app-settings-organisation-manage-access-modals-error-domain-already-access-1",
    false,
    { domain: email?.match(/@([a-zA-Z0-9.-]+)$/)?.[1] || "" },
  );
});
const rules = {
  email: {
    required: helpers.withMessage(
      () => getComponentUiText("app-common-form-value-required-error-1"),
      required,
    ),
    specialChar: helpers.withMessage(
      () =>
        getComponentUiText("app-base-input-email-invalid-special-characters-1"),
      IsEmailValidWhileTyping,
    ),
    notDomainValid: helpers.withMessage(
      () => getDomainMessage.value,
      validateForDomain,
    ),
    email: helpers.withMessage(
      () =>
        getComponentUiText("app-base-input-email-invalid-special-characters-1"),
      IsSpecialCharEmailValid,
    ),
  },
  orgToOrgTypeId: {
    required: helpers.withMessage(
      () => getComponentUiText("app-common-form-value-required-error-1"),
      required,
    ),
  },
  isLocked: {
    required: helpers.withMessage(
      () => getComponentUiText("app-common-form-value-required-error-1"),
      required,
    ),
  },
  roleId: {
    required: helpers.withMessage(
      () => getComponentUiText("app-common-form-value-required-error-1"),
      required,
    ),
  },
};

const vueValidate = useVuelidate(rules, formModel);
let showRef = ref(props.show);
let notInfoVisible = ref(true);

const clearData = () => {
  for (const key in formModel) {
    if (Array.isArray(formModel[key])) {
      formModel[key].splice(0); // Clear the array content while maintaining reference
    } else {
      formModel[key] = initialForm[key];
    }
  }

  vueValidate.value.$reset();
};

const handleCloseModal = () => {
  clearData();
  showRef.value = false;
  emit("update:show", showRef.value);
};

watch(
  () => props.show,
  (value) => {
    showRef.value = value;
    if (value) notInfoVisible.value = true;
  },
);

const toastSuccess = getComponentUiText(
  "app-settings-organisation-manage-access-offer-modal-toast-org-offer-access-1",
);

const onSubmit = async () => {
  await vueValidate.value.$validate();
  if (vueValidate.value.$invalid) return;

  try {
    isCallApi.value = true;
    const formResponse = await postOrgAccessOffer({
      ...formModel,
      roleId: `${formModel.roleId}`,
    });
    if (formResponse.data?.data) {
      emit("add:organisation", formResponse.data.data);
      onShowToast(toastSuccess, ToastVariant.SUCCESS);
      handleCloseModal();
    }
  } catch (error: any) {
    if (error && error.data) {
      showErrorAPI(error, Invite.orgAccessOffer);
    }
  } finally {
    isCallApi.value = false;
  }
};

const onShowToast = (message: string, variant: ToastVariant) => {
  const emitData: IToastMessage = { variant, message };
  EventEmitter.emit(EmitterEvents.APP_LAYOUT_SHOW_TOAST_MESSAGE, emitData);
};

const getFormData = async () => {
  titleHeader.value = getComponentUiText(
    "app-settings-organisation-manage-access-offer-modal-title-1",
    false,
    { name: currentOrg.value.name },
  );
};

const handleLockStatus = () => {
  const isShowLockStatus =
    orgRelationshipOptions.value.find(
      (org) => org.id === formModel.orgToOrgTypeId,
    )?.isLockable === true;
  if (isShowLockStatus) return true;
  return false;
};

onBeforeMount(() => {
  getFormData();
});

watch(
  () => currentOrg.value,
  async (newValue, oldValue) => {
    if (newValue.id && newValue.id !== oldValue.id) {
      await getFormData();
    }
  },
  { deep: true },
);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(Modal, {
    class: "tw-translate-y-[-50%] offer-access-modal",
    "max-width": DEFAULT_MAX_WIDTH_MODAL,
    visible: _unref(showRef),
    value: formModel,
    onClose: handleCloseModal
  }, {
    default: _withCtx(() => [
      _createVNode(ModalHeader, {
        title: titleHeader.value,
        onClose: handleCloseModal
      }, null, 8, ["title"]),
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("span", _hoisted_3, _toDisplayString(_unref(getComponentUiText)(
              "app-settings-organisation-manage-access-offer-modal-subtitle-1",
            )), 1)
        ]),
        _createVNode(BaseForm, {
          show: _unref(showRef),
          "enter-event": true,
          "onOn:submit": onSubmit
        }, {
          default: _withCtx(() => [
            _createVNode(BaseInput, {
              id: "name",
              modelValue: formModel.email,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((formModel.email) = $event)),
              validation: _unref(vueValidate).email,
              "validate-on-blur": true,
              label: _unref(getComponentUiText)('app-user-profile-form-label-email-1'),
              "label-tooltip": 
            _unref(getComponentUiText)(
              'app-settings-organisation-manage-access-offer-modal-description-email-1',
            )
          ,
              placeholder: 
            _unref(getComponentUiText)('app-user-profile-form-label-email-1')
          
            }, null, 8, ["modelValue", "validation", "label", "label-tooltip", "placeholder"]),
            _createVNode(BaseInput, {
              id: "lock-status",
              modelValue: formModel.orgToOrgTypeId,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((formModel.orgToOrgTypeId) = $event)),
              validation: _unref(vueValidate).orgToOrgTypeId,
              "validate-on-blur": true,
              label: 
            _unref(getComponentUiText)(
              'app-settings-organisation-manage-access-modals-label-org-relationship-1',
            )
          
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_4, [
                  _createVNode(BaseDropDown, {
                    id: 'orgToOrgTypeId',
                    modelValue: formModel.orgToOrgTypeId,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((formModel.orgToOrgTypeId) = $event)),
                    data: orgRelationshipOptions.value,
                    validation: _unref(vueValidate).orgToOrgTypeId,
                    "class-name": 'gray-dropdown-container tw-h-[58px]',
                    placeholder: 
                _unref(getComponentUiText)(
                  'app-settings-organisation-manage-access-modals-prompt-org-relationship-1',
                )
              
                  }, null, 8, ["modelValue", "data", "validation", "placeholder"])
                ])
              ]),
              _: 1
            }, 8, ["modelValue", "validation", "label"]),
            (handleLockStatus())
              ? (_openBlock(), _createBlock(BaseInput, {
                  key: 0,
                  id: "lock-status",
                  modelValue: formModel.isLocked,
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((formModel.isLocked) = $event)),
                  validation: _unref(vueValidate).isLocked,
                  label: 
            _unref(getComponentUiText)(
              'app-settings-organisation-manage-access-modals-label-lock-status-1',
            )
          ,
                  "label-tooltip": 
            _unref(getComponentUiText)(
              'app-settings-organisation-manage-access-offer-modal-description-lock-status-1',
            )
          ,
                  "validate-on-blur": true
                }, {
                  feedback: _withCtx(() => [
                    (formModel.isLocked === false)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                          _hoisted_11,
                          _createElementVNode("span", null, _toDisplayString(_unref(getComponentUiText)(
                  "app-settings-organisation-manage-access-modals-warning-lock-status-1",
                )), 1)
                        ]))
                      : _createCommentVNode("", true)
                  ]),
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_5, [
                      _createVNode(BaseDropDown, {
                        id: 'isLocked',
                        modelValue: formModel.isLocked,
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((formModel.isLocked) = $event)),
                        data: lockStatusOptions,
                        validation: _unref(vueValidate).isLocked,
                        "class-name": 'gray-dropdown-container tw-h-[58px]',
                        placeholder: 
                _unref(getComponentUiText)(
                  'app-settings-organisation-manage-access-modals-prompt-lock-status-1',
                )
              
                      }, {
                        "button-content": _withCtx(() => [
                          _createElementVNode("div", _hoisted_6, [
                            _createElementVNode("div", null, [
                              (formModel.isLocked)
                                ? (_openBlock(), _createElementBlock("img", _hoisted_7))
                                : _createCommentVNode("", true),
                              _createElementVNode("span", _hoisted_8, _toDisplayString(lockStatusOptions.find(
                        (m) => m.value === formModel.isLocked,
                      )?.name), 1)
                            ]),
                            _hoisted_9
                          ])
                        ]),
                        _: 1
                      }, 8, ["modelValue", "validation", "placeholder"])
                    ])
                  ]),
                  _: 1
                }, 8, ["modelValue", "validation", "label", "label-tooltip"]))
              : _createCommentVNode("", true),
            _createVNode(BaseInput, {
              modelValue: formModel.roleId,
              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((formModel.roleId) = $event)),
              validation: _unref(vueValidate).roleId,
              placeholder: 
            _unref(getComponentUiText)('app-component-custom-b-dropdown-prompt-roles-1')
          ,
              label: 
            _unref(getComponentUiText)(
              'app-settings-organisation-manage-access-manage-offer-modal-form-label-role-1',
            )
          
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_12, [
                  _createVNode(BaseDropDown, {
                    id: 'roleId',
                    modelValue: formModel.roleId,
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((formModel.roleId) = $event)),
                    data: roles.value,
                    validation: _unref(vueValidate).roleId,
                    "class-name": 'gray-dropdown-container tw-min-h-[58px] tw-text-[#FFFFFF]',
                    placeholder: 
                _unref(getComponentUiText)(
                  'app-component-custom-b-dropdown-prompt-roles-1',
                )
              
                  }, null, 8, ["modelValue", "data", "validation", "placeholder"])
                ])
              ]),
              _: 1
            }, 8, ["modelValue", "validation", "placeholder", "label"]),
            _createElementVNode("div", _hoisted_13, [
              _createVNode(ButtonLoading, {
                class: _normalizeClass(`button-verify tw-bg-[#387DFF] tw-text-[15px] tw-font-medium tw-rounded-[27px]`),
                title: 
              _unref(getComponentUiText)(
                'app-settings-organisation-manage-access-offer-modal-offer-access-button-1',
              )
            ,
                "is-loading": isCallApi.value,
                type: "submit"
              }, null, 8, ["title", "is-loading"])
            ])
          ]),
          _: 1
        }, 8, ["show"])
      ])
    ]),
    _: 1
  }, 8, ["visible", "value"]))
}
}

})